<template>
  <main>
    <div class="container-fluid pt-3">
      
      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">사이트 설정</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12 col-lg-6 mb-4">
          <Auth></Auth>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <IP></IP>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import { mapMutations } from "vuex";
import Auth from "@/components/Site/Auth.vue";
import IP from "@/components/Site/IP.vue";
export default {
  name: "profile",
  components:{
    
    Auth,
    IP,
},
  data() {
    return {
      showMenu: false,
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,

    };
  },

  mounted() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;
    
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      } 
    }

  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
  }
};
</script>

